import { createFileRoute } from '@tanstack/react-router';
import { SwitchSignalsPage } from '../../../pages/tools/research-tools/SwitchSignalsPage';
import { toolHead } from '../../../lib/toolHead';

export const Route = createFileRoute('/_site/tools/switch-signals')({
  head: () => toolHead('switch-signals'),
  component: SwitchSignalsPage,
});
